<template>
  <v-card outlined class="pa-3 quarter-card">

    <div class="d-flex justify-space-between">
      <strong>{{ quarter.name }}</strong>

      <span class="grey--text">
        {{ quarter.actions.length }} actions
      </span>
    </div>

    <div class="mt-2">
      <div>
        coût
        <strong>{{ quarter.totalCost }} €</strong>
      </div>

      <div class="green--text">
        net
        <strong>{{ quarter.totalProfit }} €</strong>
      </div>
    </div>

    <!-- Scrollable area -->
    <div class="actions-container mt-3">
      <ActionCard
        v-for="action in quarter.actions"
        :key="action.id"
        :action="action"
      />
    </div>

  </v-card>
</template>
  
  <script>
  import ActionCard from "./ActionCard.vue";
  
  export default {
    props: {
      quarter: Object
    },
  
    components: {
      ActionCard
    }
  };
  </script>
  
<style scoped>
.quarter-card {
  height: 700px;
  display: flex;
  flex-direction: column;
}

.actions-container {
  overflow-y: auto;
  flex: 1;
}
</style>
